import {
  BuilderElement,
  Component as BuilderComponent,
  Input as BuilderInput,
} from '@builder.io/sdk';
import { ComponentType } from 'react';

export type BuilderComponentProps = {
  builderBlock: BuilderElement;
};

/**
 * Valid Input "type" values
 * @see https://www.builder.io/c/docs/custom-react-components
 */
type InputType =
  | 'AIPrompt'
  | 'boolean'
  | 'cloudinaryImage'
  | 'cloudinaryMediaLibrary'
  | 'color'
  | 'date'
  | 'email'
  | 'file'
  | 'list'
  | 'longText'
  | 'number'
  | 'object'
  | 'richText'
  | 'string'
  /**
   * https://forum.builder.io/t/react-custom-component-containing-editable-subcomponents/25/2
   */
  | 'uiBlocks';

/**
 * Enhance BuilderInput with enhanced InputType
 */
export interface Input extends BuilderInput {
  type: InputType;
  subFields?: Input[];
}

/**
 * Enhance Builder's Component and rename to ComponentConfig
 */
export interface ComponentConfig extends BuilderComponent {
  inputs: Input[];
}

/**
 * Each Builder Component should declare a BuilderModule
 */
export type BuilderModule = {
  Component: ComponentType<any>;
  config: ComponentConfig;
};

/**
 * Builder module factory
 *
 * This helper exists to centralize the creation of BuilderModules.
 * Each SomeComponent.builder.ts module should export a config using this.
 */
export function createBuilderModule(
  Component: BuilderModule['Component'],
  config: BuilderModule['config'],
): BuilderModule {
  return {
    Component,
    config,
  };
}
